import { render, staticRenderFns } from "./Page.vue?vue&type=template&id=75e6a4d0&scoped=true&"
import script from "./Page.vue?vue&type=script&lang=js&"
export * from "./Page.vue?vue&type=script&lang=js&"
import style0 from "./Page.vue?vue&type=style&index=0&id=75e6a4d0&prod&lang=scss&scoped=true&"
import style1 from "./Page.vue?vue&type=style&index=1&id=75e6a4d0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75e6a4d0",
  null
  
)

export default component.exports